

import { createContext } from 'react';

import type { ButtonGroupContextInterface } from '../types/button-group.types';

export const ButtonGroupContext = createContext<ButtonGroupContextInterface>({});

ButtonGroupContext.displayName = 'ButtonGroup.Context';
